import React, { Component } from "react";
import {
  Breadcrumb,
  PageHeader,
  ListGroup,
  Glyphicon,
  Grid
  } from "react-bootstrap";
import config from './config';
import './Info.css';

export class LinkDoc extends Component {
  render() {
	return (
	  <a href={this.props.href} className="list-group-item" target="_blank">
	  	{this.props.children}
	  </a>
	);
  }
}
export default class Info extends Component {
  constructor(props) {
	super(props);
	this.state = {
	  isLoading: true
	};
  }
  renderLink(doc, name) {
	  const base = 'https://s3-' + config.AWS.REGION + '.amazonaws.com/' + window.location.hostname;
	  return (
		<LinkDoc href={base+"/docs/"+doc+".pdf"}><Glyphicon glyph="download-alt" /> {name}</LinkDoc>
	  );
  }
  render() {
    return (
      <div className="Info">
      <Grid>
        <Breadcrumb>
  	      <Breadcrumb.Item href="/">Inicio</Breadcrumb.Item>
  	      <Breadcrumb.Item active>Informaci&oacute;n</Breadcrumb.Item>
  	    </Breadcrumb>
  	    <PageHeader>
  	      Informaci&oacute;n
  	    </PageHeader>
  	    <p>Aqu&iacute; encontrar&aacute;s informaci&oacute;n &uacute;til para tu vida en comunidad.</p>
        <ListGroup>
  	      { this.renderLink("Ley_20296_Ascensores", "Ley de Ascensores") }
  	      { this.renderLink("Que_hacer_en_caso_de_incendio", "Qué hacer en caso de incendio") }
  	      { this.renderLink("Recomendaciones_Prevencion_de_Incendios", "Recomendaciones Prevención de Incendios") }
  	      { this.renderLink("Reglamento_piscinas", "Reglamento Piscinas") }
  	      { this.renderLink("Resolucion_exenta_SEC_489_Instalacion_Gas", "Resolución Exenta SEC Nº 489 Instalación Gas") }
  	      { this.renderLink("Modificacion_decreto_N_209_de_2002", "Modificación decreto Nº 209 de 2002") }
  	      { this.renderLink("Los_gastos_comunes", "Gastos Comunes") }
  	    </ListGroup>
        <p>(*) Necesitas un visor de PDF</p>
      </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Info.js